import React, { Component } from 'react'
import styled, { keyframes } from 'styled-components'
import { media, mediaUp } from '@utils/mediaQuery'
import { isIOS } from 'react-device-detect'
import MobileDetect from 'mobile-detect'

const moveBar = keyframes`
  0% {
    transform: scaleY(0);
  }
  50% {
    transform: scaleY(1);
  }
  100% {
    transform: scaleY(0);
  }
`;


const AudioPlayerContainer = styled.div`
  position: absolute;
  bottom: 50px;
  right: 50px;
  z-index: 2;
  width: 30px;
  height: 26px;
  z-index: 1000;
  cursor: pointer;
  .inner {
    display: flex;
    flex-direction: row;
    position: relative;
    width: 30px;
    height: 16px;
  }
  ${media.xs`
    bottom: inherit;
    top: ${props => props.iOS ? `calc(85vh - 65px)`: `calc(82.5vh)`};
    right: 30px;
  `}
`

const Circle = styled.span`
  display: block;
  width: 54px;
  height: 54px;
  border-radius: 50%;
  background-color: black;
  z-index: -1;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
`

const AudioBar = styled.span`
  display: block;
  height: 16px;
  margin: 0 2px;
  position: relative;
  bottom: -2px;
  background-color: white;
  transform-origin: bottom center;
  transform: scaleY(${props => props.scale});
  border-right: 5px solid white;
  animation-duration: 1s;
  animation-timing-function: steps(4);
  animation-delay: ${props => props.delay};
  animation-play-state: paused;
  animation-fill-mode: both;
  animation-iteration-count: infinite;
  &.light {
    border-color: black;
  }
  &.playing {
    transform: inherit;
    animation-name: ${moveBar};
    animation-play-state: running;
  }
  &.paused {
    transform: inherit;
    animation-name: ${moveBar};
    animation-play-state: paused;
  }
`


class AudioPlayer extends Component {

  constructor(props) {
    super(props);
    this.state = {
      muted: false,
      isMobile: false,
      isIOS: false,
    }
    // this.sound = null
    this.toggleAudio = this.toggleAudio.bind(this)
  }

  componentDidMount() {
    if (typeof window == 'object') {
      let md = new MobileDetect(window.navigator.userAgent);

      this.setState({
        isMobile: md.mobile() !== null ? true : false,
        isIOS : md.is('iPhone')
      })

    }
  }

  toggleAudio() {
    // get current mute status
    let muted = this.props.video.current.muted

    // invert mute
    this.props.video.current.muted = !muted
    this.setState({
      muted: !muted
    })
  }

  render() {

    const audioBarClassName = () => {
      let classNames = [];

      // add current theme
      classNames.push(this.props.theme)

      // add playing state
      if (this.props.animating === true && !this.state.muted) {
        classNames.push('playing')
      }

      if (this.props.animating === false || this.state.muted) {
        classNames.push('paused')
      }

      // return all classes
      return classNames.join(' ')
    }

    return (
      <AudioPlayerContainer onClick={(e) => this.toggleAudio()} iOS={this.state.isIOS} visible={true} className={this.props.theme}>
        <div className="inner">
          <AudioBar delay={`0s`} scale={0.5} className={audioBarClassName()} />
          <AudioBar delay={`0.25s`} scale={0.25} className={audioBarClassName()} />
          <AudioBar delay={`0.35s`} scale={1} className={audioBarClassName()} />
          <Circle />
        </div>
      </AudioPlayerContainer>
    );
  }
}

export default AudioPlayer

